module.exports = __webpack_public_path__ + "img/tether_to_sUSDT_swap_256.4dfe38bc.png";